import styles from './MobileHeaderCard.module.scss';

export const VariantMap = new Map([
  ['ready_for_pickup', styles.ready_for_pickup],
  ['ready_to_ship', styles.ready_to_ship],
  ['picking', styles.picking],
  ['in_delivery', styles.in_delivery],
  ['select', styles.asSelect],
  ['express', styles.express],
]);

export const CAPTION_SKELETON_DEFAULT_WIDTH = 117;
export const TITLE_SKELETON_DEFAULT_WIDTH = 81;
